module.exports = __webpack_public_path__ + "BradescoSans-Regular.3640e6cadf1f7a55ff24.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Regular.woff
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Regular.woff
// module chunks = main